import { render, staticRenderFns } from "./Demographics.vue?vue&type=template&id=3107a1b1"
import script from "./Demographics.vue?vue&type=script&lang=js"
export * from "./Demographics.vue?vue&type=script&lang=js"
import style0 from "./Demographics.vue?vue&type=style&index=0&id=3107a1b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports